import React from "react"
import { graphql, useStaticQuery } from 'gatsby'
import Img from "gatsby-image"

import { Nav, NavItem, StyledHeader } from './styles'

const Header = () => {
  const data = useStaticQuery(graphql`
      query HeaderQuery {
          file(relativePath: { eq: "logo.png" }) {
              childImageSharp {
                  fixed(width: 200) {
                      ...GatsbyImageSharpFixed_withWebp
                  }
              }
          }
      }
  `)

  return (
    <StyledHeader>
      <Img fixed={data.file.childImageSharp.fixed} />
      <Nav>
        <NavItem href='/' title='The Bean Emporium Home'>
          Home
        </NavItem>
        <NavItem href='/#refillable-coffee-pods' title='Refillable Coffee Pods'>
          Refillable Coffee Pods
        </NavItem>
        <NavItem href='/#how-to-use' title='How To Use Refillable Coffee Pods'>
          How To Use
        </NavItem>
        <NavItem href='/#contact-us' title='Contact The Bean Emporium'>
          Contact Us
        </NavItem>
      </Nav>
    </StyledHeader>
  )
}

export default Header